





import { Component, Prop, Watch } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import { AppModule } from "@/store/modules/app";
import { AgencyDashboardModule } from "@/store/modules/agencyDashboard";
import { MessagingModule } from "@/store/modules/messaging";
import ConversationTopicDto from "@/models/ConversationTopics/ConversationTopicDto";
import { doc, getDocs, onSnapshot, limit, query, collection, setDoc, addDoc, where, orderBy, QueryFieldFilterConstraint, getCountFromServer, AggregateQuerySnapshot, aggregateQuerySnapshotEqual } from "firebase/firestore";
import db from '@/firebase/init';

@Component({
  name: "ConversationTopicCountChip",
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  conversationTopic: ConversationTopicDto;
  count = 0;
  snapshot: any;
  async beforeMount() {
    // const coll = collection(db, "MessagingTest/833c705a-559d-45be-8877-6adef11bf30f/conversationTopics/" + this.conversationTopic.id + "/conversations");
    // const q = query(coll, where("status", "==", "New"));
    // this.snapshot = await getCountFromServer(q);
    // this.count = this.snapshot.data().count;
  }

}
